var _circle, _path, _path2, _path3, _g, _g2, _path4, _path5, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKenya(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "#f0f0f0",
    r: 256
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m256 0c-101.494 0-189.19 59.065-230.598 144.696h461.195c-41.407-85.631-129.104-144.696-230.597-144.696z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m256 512c-101.494 0-189.19-59.065-230.598-144.696h461.195c-41.407 85.631-129.104 144.696-230.597 144.696z",
    fill: "#496e2d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m499.911 178.087h-487.822c-7.842 24.569-12.089 50.744-12.089 77.913s4.247 53.344 12.089 77.913h487.821c7.843-24.569 12.09-50.744 12.09-77.913s-4.247-53.344-12.089-77.913z",
    fill: "#a2001d"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#f0f0f0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m335.715 118.301-30.317-13.993-49.398 111.851-49.398-111.851-30.317 13.993 61.328 137.699-61.328 137.699 30.317 13.993 49.398-111.851 49.398 111.851 30.317-13.993-61.328-137.699z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m276.591 131.489c-11.736-12.817-20.591-20.185-20.591-20.185s-8.855 7.367-20.591 20.185v249.02c11.736 12.819 20.591 20.187 20.591 20.187s8.855-7.367 20.591-20.186z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#a2001d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m200.348 179.243v153.512c12.402 21.975 27.581 39.987 38.957 51.929v-257.369c-11.376 11.941-26.556 29.954-38.957 51.928z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m311.652 179.243c-12.403-21.975-27.581-39.987-38.957-51.928v257.369c11.375-11.942 26.554-29.954 38.957-51.929z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m311.652 179.243v153.512c12.555-22.249 22.261-48.558 22.261-76.755s-9.706-54.507-22.261-76.757z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m200.348 179.243v153.512c-12.555-22.249-22.261-48.558-22.261-76.755s9.706-54.507 22.261-76.757z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKenya);
export default __webpack_public_path__ + "static/media/kenya.797901b1b422f2abf4f1395cc2b29840.svg";
export { ForwardRef as ReactComponent };